import React, { Component } from 'react';
import SimpleWaveform from 'components/SimpleWaveform.js';

class SampleListComponent extends Component {
    render() {
        return (
            <div className="sample-list">
              {this.props.soundIds !== undefined &&
              this.props.soundIds.length > 0 ? <div className="sub-header">Samples:</div> : ''}
              {this.props.sounds.map(
                  (sound, i) =>
                      <SimpleWaveform
                            dragging={(buffer) => []}
                            isSelected={this.props.selectedSound == sound}
                            onClick={() => []}
                            buffer={sound.audioBuffer}
                            sound={sound}
                            width={100}
                            height={60}
                            segments={[]}
                            onClickDelete={() => this.props.onClickDelete(i)}
                            ></SimpleWaveform> 
              )}
            </div>
        );
    }
}

export default SampleListComponent;
